import Swiper from 'swiper'

$(() => {
  $('.wpce-swiper').each(function () {
    let $swiper = $(this)

    let options = {
      // Optional parameters
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
      speed: 300,
      direction: 'horizontal',
      slidesPerView: 6,
      spaceBetween: 15,
      breakpointsInverse: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      threshold: 5,
      ...$swiper.data('options'),
    }

    let swiper = new Swiper(`#${$swiper.data('swiper-id')}`, options)

    // Make swiper instance available via element.__swiper
    $swiper.prop('__swiper', swiper)

    let $prevButton = $swiper.find('.custom-button-prev')

    $prevButton.click(() => {
      swiper.slidePrev()
    })
    let $nextButton = $swiper.find('.custom-button-next')
    $nextButton.click(() => {
      swiper.slideNext()
    })

    let checkButtonsEnabled = () => {
      if (swiper.isEnd) {
        $nextButton.prop('disabled', true)
      } else {
        $nextButton.prop('disabled', false)
      }
      if (swiper.isBeginning) {
        $prevButton.prop('disabled', true)
      } else {
        $prevButton.prop('disabled', false)
      }
    }
    checkButtonsEnabled()
    swiper.on('slideChange', checkButtonsEnabled)

    swiper.on('touchStart', () => {
      $swiper.addClass('no-edges')
    })
    swiper.on('touchEnd', () => {
      $swiper.removeClass('no-edges')
    })
  })
})
